/*
CUSTOMIZATIONS:
- customized title for this section: from 'Allegati' to 'Documenti'
*/
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Attachments } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  news_item_documenti: {
    id: 'news_item_documenti',
    defaultMessage: 'Documenti',
  },
});

const NewsItemAllegati = ({ content }) => {
  const intl = useIntl();
  return (
    <Attachments
      content={content}
      folder_name={'documenti-allegati'}
      title={intl.formatMessage(messages.news_item_documenti)}
    />
  );
};

NewsItemAllegati.propTypes = {
  content: PropTypes.object.isRequired,
};

export default NewsItemAllegati;
